import React, { Dispatch } from "react";
import { Toggle } from "@amzn/awsui-components-react";
import { FullAsin } from "../../server/asin-central/model";
import { useDispatch, useSelector } from "react-redux";
import {
  GetOclKeyFromFullAsin,
  set3pse,
  setIndexSuppressed,
} from "./oneClickLaunchConnector";
import { capitalize } from "../../util/stringUtils";
import { RootState } from "../app/rootReducer";

export interface ItemToggleProps {
  type: ItemToggleType;
  item: FullAsin;
}

export type ItemToggleType = "indexSuppressed" | "3PSE";

const dispatchActions = {
  indexSuppressed: (item: FullAsin, isSet: boolean, dispatch: Dispatch<any>) =>
    dispatch(setIndexSuppressed({ item: item, value: isSet })),
  "3PSE": (item: FullAsin, isSet: boolean, dispatch: Dispatch<any>) =>
    dispatch(set3pse({ item: item, value: isSet })),
};

export default (props: ItemToggleProps) => {
  const dispatch = useDispatch();
  const { indexSuppressedSelectedMap, _3pseSelectedMap } = useSelector(
    (state: RootState) => state.oneClickLaunch
  );
  const checked =
    (props.type === "indexSuppressed"
      ? indexSuppressedSelectedMap[GetOclKeyFromFullAsin(props.item)]
      : _3pseSelectedMap[GetOclKeyFromFullAsin(props.item)]) ?? false;
  return (
    <div style={{ textAlign: "center", display: "flex" }}>
      <div style={{ margin: "auto" }}>
        <Toggle
          onChange={({ detail }) => {
            dispatchActions[props.type]?.(props.item, detail.checked, dispatch);
          }}
          checked={checked}
        >
          {capitalize(`${checked}`)}
        </Toggle>
      </div>
    </div>
  );
};
